module.exports = __webpack_public_path__ + "static/responsive-771984d5781f2ffabe0e5b5d26b15265.svg";